<template>
  <div class="modal" :class="{'is-init': init}">
    <div @click="onClose" class="modal__overlay"></div>
    <div class="modal__wrapper">
      <div class="modal__content">
        <div v-if="$slots['main']" class="modal__content-main">
          <slot name="main"/>
        </div>
        <div v-if="$slots['side']" class="modal__content-side">
          <slot name="side"/>
        </div>
      </div>
      <div class="modal__footer block">
        <div class="block-wrapper">
          <div class="modal__footer-wrapper block-wrapper">
            <div class="modal__footer-main">
              {{ buildDate }} | {{ buildVersion }}
            </div>
            <div class="modal__footer-side">
              <!--              {{ $t('common.copyright') }}-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ModalBase',
  data() {
    return {
      init: false,
      timeoutId: null,
      buildDate: process.env.VUE_APP_BUILD,
      buildVersion: process.env.VUE_APP_VERSION
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    }
  },
  mounted() {
    this.timeoutId = setTimeout(() => {
      this.init = true
    }, 100)
  },
  beforeDestroy() {
    clearTimeout(this.timeoutId)
  }
}
</script>
